import CustomTable from './edit_table';

export default CustomTable;
